<template>
    <DialogBox :settings="settings" @show="initialiseDialog">
        <div class="pa-4">

        <div class="section-heading vertical-margin">Main</div>
        <v-text-field v-model="element.title" label="Title"></v-text-field>
        <v-text-field v-model="element.name" label="Name"></v-text-field>
        
        <div class="section-heading vertical-margin">Display</div>
        <v-select :items="[1,2]" v-model="element.columns" label="Columns" />

        <div style="display:flex;width:100%">
            <div v-for="(column, index) in element.columns" style="margin-right:5px;flex-grow:1" :key="index">
                <div class="section-heading vertical-margin">Column {{index + 1}}</div>
                <v-text-field v-model="column.title" label="Title"></v-text-field>

            </div>
        </div>
                
        </div>
    </DialogBox>
</template>

<script>
import DialogBox from '../ui-elements/DialogBox'

export default {
    data() {
        return {
        
        }
    },

    components: {
        DialogBox,
    },
    
    props: {
        settings: Object,
        element: Object,
    },

    computed: {
        property1() {

        }
    },

    methods: {
        initialiseDialog() {

        },
    },

    created() {

    }
}
</script>

<style scoped>
    .section {
        padding:4px 8px;color:white;background-color: #aaa;font-weight:600;
        border-radius:7px;text-transform: uppercase; margin: 10px 0;
    }   
</style>




// WEBPACK FOOTER //
// ElementDialog.vue?1287ae2a